import ScrollableContainer from '../ScrollableContainer';
export var ScrollableContainerCommonProps = {
    onScrollAreaChanged: ScrollableContainer.propTypes['onScrollAreaChanged'],
    onScrollChanged: ScrollableContainer.propTypes['onScrollChanged'],
};
//# sourceMappingURL=ScrollableContainerCommon.js.map